var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPledged(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pledged") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-/-S2-01-1_Idea-details_join_team-9",
    transform: "translate(-1004.000000, -337.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(785.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pledged",
    transform: "translate(219.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    stroke: "#7834FF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22,
    cy: 22,
    r: 21.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "deals",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.63,18.3983333 L25.4633333,20.03 C26.2432037,20.4807501 26.5102826,21.478193 26.06,22.2583333 L26.06,22.2583333 C25.6092499,23.0382037 24.611807,23.3052826 23.8316667,22.855 L16.7666667,18.7766667",
    id: "Path",
    stroke: "#7834FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4116667,22.0416667 C23.1885168,22.4952638 23.4516894,23.492039 23,24.27 L23,24.27 C22.5492499,25.0498703 21.551807,25.3169493 20.7716667,24.8666667 L15.1266667,21.6033333",
    id: "Path",
    stroke: "#7834FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3666667,24.0516667 C20.146537,24.5024168 20.4136159,25.4998596 19.9633333,26.28 L19.9633333,26.28 C19.5125832,27.0598703 18.5151404,27.3269493 17.735,26.8766667 L17.5466667,26.7683333 L6.62,20.46 L6.43166667,20.3516667 C4.93212055,19.4863528 3.83782377,18.0606908 3.38959224,16.3884183 C2.9413607,14.7161459 3.1759253,12.9342994 4.04166667,11.435 L5.67333333,8.60166667 C7.47809261,5.48299954 11.4687092,4.41689537 14.5883333,6.22 L15.1566667,6.55333333",
    id: "Path",
    stroke: "#7834FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0866667,17.205 L27.29,16.8516667 C29.0919852,13.7302973 28.0227527,9.73914258 24.9016667,7.93666667 L22.0683333,6.305 C18.9499413,4.51207927 14.9687652,5.58023606 13.1666667,8.69333333 L8.77166667,16 L9.93833333,16.4383333 C10.6468329,16.7042515 11.4447442,16.5475074 12,16.0333333 L14.82,12.975 C16.7583333,13.8 18.085,13.265 19.1766667,12.6416667 L27.0916667,17.2083333 C27.871537,17.6590835 28.1386159,18.6565263 27.6883333,19.4366667 L27.6883333,19.4366667 C27.2375832,20.216537 26.2401404,20.4836159 25.46,20.0333333 L18.39,15.9516667",
    id: "Path",
    stroke: "#7834FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPledged);
export default __webpack_public_path__ + "static/media/pledged.ee7fb2a49ad5f74fae2509555ac76e4c.svg";
export { ForwardRef as ReactComponent };